@if (validContacts.length > 0) {
  <div class="d-flex flex-column gap-1 py-1">
    <!-- First number: always shown the same way as when there is only one -->
    <a
      class="d-flex align-items-center gap-2"
      [ngbTooltip]="'Call Now'"
      placement="top"
      [href]="'tel:' + getPhoneNumber(validContacts[0])"
    >
      <i class="bi bi-{{ getIconForContact(validContacts[0]) }} fs-16 text-primary"></i>
      <span>{{ getPhoneNumber(validContacts[0]) }}</span>
    </a>
    @if (validContacts.length > 1) {
      <span
        class="badge bg-gray-200 text-black fw-500 rounded-4 py-1 px-2 cursor-pointer align-self-start fs-14"
        [ngbPopover]="popoverTitle2"
        placement="bottom-left"
        triggers="click"
        >more</span
      >
    }
  </div>
}
<ng-template #popoverTitle2>
  <div class="d-flex flex-column gap-2 p-1">
    <span class="small fw-semibold text-secondary">Other phone numbers</span>
    @for (
      contact of validContacts.slice(1);
      track contact.id ?? contact.phoneNumber ?? contact.PhoneNumber ?? contact
    ) {
      <div class="d-flex align-items-center gap-2">
        <i class="bi bi-{{ getIconForContact(contact) }} text-primary"></i>
        <a [href]="'tel:' + getPhoneNumber(contact)">{{ getPhoneNumber(contact) }}</a>
      </div>
    }
  </div>
</ng-template>
